import _defineProperty from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var genCollapseMotion = function genCollapseMotion(token) {
  return _defineProperty({}, token.componentCls, _defineProperty(_defineProperty({}, "".concat(token.antCls, "-motion-collapse-legacy"), {
    overflow: 'hidden',
    '&-active': {
      transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
    }
  }), "".concat(token.antCls, "-motion-collapse"), {
    overflow: 'hidden',
    transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
  }));
};
export default genCollapseMotion;